import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from './index'

/**
 * Typed `useDispatch` — RTK Query only.
 * App state lives in Zustand stores (see src/stores/).
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

/**
 * Typed `useSelector` — RTK Query cache only.
 * App state lives in Zustand stores (see src/stores/).
 */
export const useAppSelector = useSelector.withTypes<RootState>()
